import { useContext, useEffect, useState } from 'react';
import MaterialIcon from '@material/react-material-icon';
import Modal from '@mui/material/Modal';
import { useDispatch } from 'react-redux';
import { Button } from '@upmc/ims.component-library';
import { ButtonGroup } from '@upmc/ims.component-library';

import { UserContext } from 'context/User/UserContext';
import Base from '../../../pages/Base/Base';
import { getMenuFavorites, getMenuItems, updateMenuFavorites } from '../_api';
import CustomSelectDropdown from './CustomSelectDropdown';
import styles from './CustomizeFavorites.module.scss';

const CustomizeFavorites = ({ onClickHideFavorites, onFavoritesUpdate = null }) => {
	const [tempFavorites, setTempFavorites] = useState([]);
	const [favorites, setFavorites] = useState([]);
	const [dropDownOptions, setDropDownOptions] = useState([]);
	const dispatch = useDispatch();
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	const fillFavorites = (favoritesArray, upperLimit) => {
		let filledFavorites = [...(favoritesArray || [])];

		while (filledFavorites.length < upperLimit) {
			filledFavorites.push({ Name: '--None--' });
		}

		return filledFavorites;
	};

	const fillTempFav = favoritesArray => {
		let filledFavorites = [...(favoritesArray || [])];
		while (filledFavorites.length < 15) {
			filledFavorites.push({ Name: '--None--' });
		}
		return filledFavorites;
	};

	const handleAdd = (e, updateIndex, menuItem) => {
		let updatedFavorites = [...tempFavorites];
		updatedFavorites[updateIndex] = menuItem;
		setTempFavorites(updatedFavorites);
	};

	const handleFavoritesUpdate = e => {
		setTempFavorites(prev => prev.filter(fav => fav[0] !== 'undefined'));
		updateMenuFavorites(user.ID, tempFavorites).then(success => {
			if (success) {
				setFavorites(tempFavorites);
				onClickHideFavorites();
				if (onFavoritesUpdate) {
					onFavoritesUpdate();
				}
			}
		});
	};

	const handleRemove = (e, updateIndex, menuItem) => {
		let updatedFavorites = [...tempFavorites];
		updatedFavorites[updateIndex] = { Name: '--None--' };
		setTempFavorites(updatedFavorites);
	};

	useEffect(() => {
		if (user?.ID) {
			getMenuFavorites(user.ID).then(fav => {
				setFavorites(
					fillFavorites(fav.MenuItems, fav.MenuItemsUpperLimit)
				);
				setTempFavorites(fillTempFav(fav.MenuItems));
			});

			getMenuItems(user.ID, dispatch)
				.then(items => {
					setDropDownOptions(
						items.data.filter(
							item =>
								item.ParentID === 0 && item.Name !== 'Favorites'
						)
					);
				})
				.catch(ex => {});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	return (
		<div>
			<Modal open={true} onClose={() => onClickHideFavorites()}>
				<div className={styles.Modal} style={{}}>
					<Base title='Customize Favorites'>
						<ButtonGroup center classes={styles.controls}>
							<Button
								startIcon={<MaterialIcon icon='cancel' />}
								variant='outlined'
								onClick={() => onClickHideFavorites()}
								id='FavUpdateCancel-Top'
							>
								Cancel
							</Button>
							<Button
								startIcon={<MaterialIcon icon='save' />}
								color='primary'
								variant='contained'
								onClick={handleFavoritesUpdate}
								className={styles.saveButton}
								id='FavUpdateSave-Top'
							>
								Save
							</Button>
						</ButtonGroup>
						<div className={styles.ModalContent}>
							{tempFavorites.map((item, index) => {
								return (
									<div
										className={styles.DropDownContainer}
										key={index}
									>
										<div className={styles.FlexCenter}>
											<div className={styles.maxwidth}>
												<CustomSelectDropdown
													label={item.Name}
													handleAdd={handleAdd}
													handleRemove={handleRemove}
													options={dropDownOptions}
													labelId={`favorite-dropdown-${item.Name}`}
													favorites={favorites}
													tempFavorites={
														tempFavorites
													}
													updateIndex={index}
												/>
											</div>
										</div>
									</div>
								);
							})}
						</div>
						<ButtonGroup classes={styles.controls} center>
							<Button
								startIcon={<MaterialIcon icon='cancel' />}
								variant='outlined'
								onClick={() => onClickHideFavorites()}
								id='FavUpdateCancel-Bottom'
							>
								Cancel
							</Button>
							<Button
								startIcon={<MaterialIcon icon='save' />}
								onClick={handleFavoritesUpdate}
								id='FavUpdateSave-Bottom'
							>
								Save
							</Button>
						</ButtonGroup>
					</Base>
				</div>
			</Modal>
		</div>
	);
};
export default CustomizeFavorites;
